export default "__VITE_ASSET__eb080d0a__"